module.exports = __webpack_public_path__ + "static/media/img1.b9938443.webp";